import type { TrigKey } from './keys';

export const vi: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Toán · Lượng giác',
  'panel.experiment': 'Thí nghiệm',
  'panel.params': 'Tham số',
  'panel.scene': 'Chọn thí nghiệm',
  'experiment.right-triangle.label': 'Tam giác vuông',
  'experiment.unit-circle.label': 'Đường tròn đơn vị',
  'experiment.wave-studio.label': 'Studio sóng',
  'experiment.identity-playground.label': 'Đẳng thức',
  'experiment.triangle-solver.label': 'Giải tam giác',
  'experiment.circular-polar.label': 'Tròn & cực',
  'hint.line1': 'Kéo điểm và trượt thanh.',
  'hint.line2': 'Nội dung giáo dục sống trong hình học, không phải văn bản.',
  'rt.angle.a': 'Góc A',
  'rt.angle.b': 'Góc B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radian',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Bám 30°/45°/60°',
  'uc.units': 'Đơn vị',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Hiện ASTC',
  'uc.snap.common': 'Bám các góc thường',
  'uc.angle.value': '∠',
  'uc.units.deg': 'độ',
  'uc.units.rad': 'rad',
  'uc.units.both': 'độ+rad',
  'ws.fn': 'Hàm',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Biên độ',
  'ws.frequency': 'B — Tần số',
  'ws.phase': 'C — Lệch pha',
  'ws.shift': 'D — Dịch đứng',
  'ws.rform.toggle': 'Đưa về dạng R',
  'ws.rform.a': 'a (hệ số sin)',
  'ws.rform.b': 'b (hệ số cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Đặt lại',
  'ws.base': 'Hiện đường cơ sở',
  'ip.id.pythagorean': 'Pythagore',
  'ip.id.reciprocal': 'Nghịch đảo',
  'ip.id.quotient': 'Thương',
  'ip.id.sum': 'Tổng',
  'ip.id.difference': 'Hiệu',
  'ip.id.double': 'Góc nhân đôi',
  'ip.id.half': 'Nửa góc',
  'ip.play': 'Phát',
  'ip.pause': 'Tạm dừng',
  'ip.step': 'Bước',
  'ip.reset': 'Đặt lại',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Trong v2 — chứng minh này cần dựng hình kỹ hơn.',
  'ts.area': 'Diện tích',
  'ts.sineRule': 'Định lý sin',
  'ts.cosineRule': 'Định lý cosin',
  'ts.ambiguous.toggle': 'Hiện tam giác ma khi mơ hồ',
  'ts.reset': 'Đặt về đều',
  'ts.snap.integers': 'Bám số nguyên',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Cạnh',
  'ts.section.angles': 'Góc',
  'ts.section.sineRule': 'Định lý sin',
  'ts.section.cosineRule': 'Định lý cosin',
  'ts.section.area': 'Diện tích',
  'cp.omega': 'Vận tốc góc',
  'cp.plot.y': 'Vẽ y (sin)',
  'cp.plot.x': 'Vẽ x (cos)',
  'cp.polar.label': 'Hình cực',
  'cp.polar.circle': 'Tròn (r = 1)',
  'cp.polar.rose': 'Hoa hồng (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioid (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Xấp xỉ góc nhỏ (sin x ≈ x)',
  'cp.play': 'Phát',
  'cp.pause': 'Tạm dừng',
  'cp.reset': 'Đặt lại',
  'cp.step': 'Bước π/12',
};
